import { useState, useEffect } from "react";
import { sendInviteLink } from "api/apiService";
import { useSnackBar } from "../snackBar/SnackBarContext";
import Info from "../../assets/icons/ic_info.svg";
import Input from "components/Input";
import Button from "components/Button";

const SubUserPopup = ({
  isOpen,
  onClose,
  setIsPopupOpen,
  mainFormData,
  inviteFormData,
  setInviteFormData,
}) => {
  const { showSnackbar } = useSnackBar();
  const [loading, setLoading] = useState(false); // ✅ loading state
  const [error, setError] = useState({
    firstName: "",
    email: "",
  });

  // const [inviteFormData, setInviteFormData] = useState({
  //   firstName: "",
  //   lastName: "",
  //   email: "",
  //   tripName: sessionStorage.getItem("tripName"),
  //   senderName: mainFormData.firstName,
  //   senderEmailId: mainFormData.email,
  // });

  if (!isOpen) return null; // Don't render unless open

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInviteFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLinkSend = async () => {
    if (loading) return; // 🚫 Stop if already sending

    let newError = { firstName: "", email: "" };

    if (!inviteFormData.firstName) {
      newError.firstName = "Please enter first name";
    }

    if (!inviteFormData.email) {
      newError.email = "Please enter email";
    }

    if (newError.firstName || newError.email) {
      setError(newError);
      return; // 🚫 stop if errors exist
    }

    try {
      setLoading(true); // ✅ start loading
      // await sendInviteLink(formData, tripName);
      setIsPopupOpen?.(false);
      // showSnackbar("success", `Invite link sent to ${inviteFormData.email}!!`);
      showSnackbar(
        "success",
        `The invite link will be sent to ${inviteFormData.email} after submitting the form.`
      );
      // setInviteFormData("");
    } catch (error) {
      console.error("Error sending invite link:", error);
      onClose?.();
      showSnackbar("error", `Error in triggering email!!`);
    } finally {
      setLoading(false); // ✅ stop loading
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-xl shadow-lg max-w-lg w-full relative md:mx-0 mx-4">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 text-xl"
        >
          &times;
        </button>
        <div className="">
          <h2 className="text-lg font-bold mb-4 w-4/5">
            Who would you like to invite to room with you on this tour?
          </h2>
          <p className="text-xs text-primary">
            Please share their full name and email address. We will send them an
            invitation to register once you complete your registration.
          </p>

          <p className="text-xs text-red-600 font-medium pt-4">
            <span className="text-secondary font-medium">Note:</span> Kindly
            remind your roommate to check their email before registering. Also,
            remind them that they need to enter your email address when they
            register.
          </p>
          <div className="pt-5">
            <Input
              label="First Name"
              name="firstName"
              placeholder="James"
              className="custom-placeholder"
              value={inviteFormData.firstName} // controlled input
              onChange={handleChange}
              required
            />
            {error.firstName && (
              <div className="flex gap-1 w-fit text-[10px] bg-red-100 text-red-600 mb-2 rounded p-[3px]">
                <img src={Info} alt="info" />
                {error.firstName}
              </div>
            )}
            <Input
              label="Last Name"
              name="lastName"
              placeholder="David"
              className="custom-placeholder"
              value={inviteFormData.lastName} // controlled input
              onChange={handleChange}
            />
            <Input
              label="Email"
              name="email"
              placeholder="jamesdavid@gmail.com"
              className="custom-placeholder"
              value={inviteFormData.email}
              onChange={handleChange}
              required
            />
          </div>
          {error.email && (
            <div className="flex gap-1 w-fit text-[10px] bg-red-100 text-red-600 mt-1 rounded p-[3px]">
              <img src={Info} alt="info" />
              {error.email}
            </div>
          )}
          <div className="mt-4 flex justify-end gap-2">
            <Button
              className={`w-full sm:w-36 h-12 text-white ${
                loading ? "bg-gray-400" : "bg-buttonColor"
              }`}
              onClick={() => {
                handleLinkSend();
              }}
              text={loading ? "Inviting..." : "Invite"} // ✅ show loader text
              disabled={loading} // disable while loading
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubUserPopup;
